import {
  CASStatus,
  Permission,
  SharePointParentFolder,
} from '@cims-online/shared'
import { useSubmittalTrackerContext } from '../../../SubmittalTrackerContext'
import { Submittal } from '../../../SubmittalTrackerContext/types'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useClosedDisabledMessage } from 'components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useCustomRowOptions(): CustomRowActionOptions<Submittal>[] {
  const {
    refetch,
    revertModal: { toggle: toggleRevert },
    pdfModal: { toggle: togglePDF },
  } = useSubmittalTrackerContext()
  const lock = useLockRowActionButton<Submittal>({
    refetch,
    parent: SharePointParentFolder.ConstructionAdminSubmittals,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== CASStatus.Unlocked.id,
  })
  const unlock = useUnlockRowActionButton<Submittal>({
    refetch,
    parent: SharePointParentFolder.ConstructionAdminSubmittals,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== CASStatus.Closed.id,
  })
  return [
    {
      permission: Permission.CreateCASPacket,
      text: 'Create Packet',
      onClick: togglePDF,
      disabled: ({ statusId }) =>
        statusId !== CASStatus.Closed.id
          ? {
              message: `Submittal must be ${CASStatus.Closed.name} to manually create a packet`,
            }
          : false,
    },
    {
      text: 'Revert',
      permission: Permission.RevertConstructionAdminSubmittal,
      disabled: useClosedDisabledMessage('reverted', CASStatus.Closed),
      hidden: ({ statusId, deleted }) =>
        deleted ||
        statusId === CASStatus.RevisionsRequested.id ||
        statusId === CASStatus.RouterReview.id,
      onClick: (record) => toggleRevert(record),
    },
    lock,
    unlock,
  ]
}
